module.exports = __webpack_public_path__ + "static/puto-cheese-2dca59eaec4f04aa683e8159840e66db.jpg";